module.exports = __webpack_public_path__ + "d5f6e38dc9751a48f095b169ce7a29a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/pattern-bg/pattern-bg-9.png
// module id = 413
// module chunks = 0